import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { logout } from '_store/user/slice';

import Spinner from 'components/atomic/Spinner';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: ${theme.spaces.regular}px;
  background-color: ${theme.colors.linkWater};
`;

const LogoutPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, []);

  return (
    <StyledContainer>
      <Spinner />
    </StyledContainer>
  );
};

export default LogoutPage;
